// import cookie from '../../lib/cookie.js'
import '../assets/scss/dashboard.scss'
import Vue from 'vue'
import { mapState } from 'vuex'

export default {
	computed: mapState({
		// arrow functions can make the code very succinct!
		userdata: state => state.auth.userdata

	}),
	data() {
			return {
					serverdata: {overview:{'hosting':0,'servers':0,'Websites':0,'domains':0}},
					token: '',
					statsdata: {'anonymous': 0,'others':0},
					subscriptions:[],
					dashboardview: false
			};
	},
	created: function () {
		let acls = this.userdata.acls ? this.userdata.acls : [];
		// if (acls.includes('dashboard/list')) {
			this.dashboardview = true;
			// console.log("SOSO")
			// console.log(acls);
			let that = this
			// if (this.$store.getters.isAuthenticated) {
				this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('shareXToken');

				this.$http.get('/dashboard',  { headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken')}}).then(resp => {
					if(resp.data.error) {
						alert("Connection failed")
						//resolve({'loginError':resp.data.error})
					}
					else {
						that.serverdata = resp.data
						// console.log(that.serverdata)
					}
				})
					.catch(err => {
						// localStorage.removeItem('shareXToken') // if the request fails, remove any possible user token if possible
						//reject(err)
					})
				this.$http.get('/websites/freestats',  { headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken')}}).then(resp => {
					if(resp.data.error) {
						alert("Connection failed")
						//resolve({'loginError':resp.data.error})
					}
					else {
						that.statsdata = resp.data
						// console.log(that.serverdata)
					}
				})
					.catch(err => {
						// localStorage.removeItem('shareXToken') // if the request fails, remove any possible user token if possible
						//reject(err)
					})

			// }
		// }
		// else {

		// }
	},
	methods: {
		fetchUser() {
			this.$auth.fetch({
				success() {
					console.log('success ' + this.context);
				},
				error() {
					console.log('error ' + this.context);
				}
			});
		},


		// showActiveSubscriptions(data) {
		// 	this.subscriptions = data
		// 	for(let a in data) {
		// 		console.log(a + " is " + data[a])
		// 	}
		// },

		navigateTo(url) {
			this.$router.push({ path: url })
		},

	}
}
